import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import type { EmailFindInterface } from '@zaoblako/shared/modules/integration/dtos/email/email-find.dto';
import type { MainSmsAccountQueryInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-query.dto';
import type { MainSmsAccountFindInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-find.dto';
import { EmailGateEnum } from '@zaoblako/shared/modules/integration/enums/email.gate.enum';
import { MainSmsIntegrationTypeEnum } from '@zaoblako/shared/modules/integration/enums/main.sms.integration.type.enum';
import { SmsGateEnum } from '@zaoblako/shared/modules/integration/enums/sms.gate.enum';
import type { MailingFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-form.dto';
import { MailingChannelEnum } from '@zaoblako/shared/modules/notification/enums/mailing.channel.enum';
import { IntegrationEmailService } from '@zaoblako/web/core/services/integration/integration-email.service';
import { IntegrationMainsmsService } from '@zaoblako/web/core/services/integration/integration-mainsms.service';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';

@Component({
  selector: 'crm-newsletter-welcome-system-select-channel',
  standalone: true,
  imports: [CommonModule, ButtonComponent, SpinnerComponent],
  templateUrl: './newsletter-welcome-system-select-channel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterWelcomeSystemSelectChannelComponent {
  public loading = false;
  @Input() public newsletter: MailingFormInterface;

  @Output() public next = new EventEmitter<void>();

  public constructor(
    private readonly integrationEmailService: IntegrationEmailService,
    private readonly integrationMainsmsService: IntegrationMainsmsService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public get MailingChannelEnum() {
    return MailingChannelEnum;
  }

  public selectChannel(channel: MailingChannelEnum) {
    this.loading = true;
    this.cdRef.markForCheck();

    this.newsletter.channel = channel;
    if (channel === MailingChannelEnum.EMAIL) {
      this.integrationEmailService.find<EmailFindInterface>().subscribe({
        next: (emails) => {
          if (this.newsletter.smsSender) {
            this.newsletter.smsSender = null;
          }
          this.newsletter.emailSender = {
            gate: EmailGateEnum.FRM,
            email: emails[0]
          };
          this.loading = false;
          this.cdRef.markForCheck();
          this.next.emit();
        },
        error: () => {
          this.loading = false;
          this.cdRef.markForCheck();
        }
      });
    } else {
      this.integrationMainsmsService
        .find<MainSmsAccountFindInterface>(<MainSmsAccountQueryInterface>{ type: MainSmsIntegrationTypeEnum.SMS })
        .subscribe({
          next: (arraySms) => {
            if (this.newsletter.emailSender) {
              this.newsletter.emailSender = null;
            }
            this.newsletter.smsSender = {
              gate: SmsGateEnum.MAIN_SMS,
              mainSmsAccount: arraySms[0]
            };
            this.loading = false;
            this.cdRef.markForCheck();
            this.next.emit();
          },
          error: () => {
            this.loading = false;
            this.cdRef.markForCheck();
          }
        });
    }
  }
}
